// Studio-Scrollys, die der Drehbuch-Zusammenbauer erzeugt hat
// (scripts/studio/drehbuch-bauen.ts → *.generated.json).
//
// Die Dateien enthalten keinen MapTiler-Schluessel; er kommt hier aus
// VITE_MAPTILER_KEY dazu (lokal public/.env.local, auf K8s Secret MAPTILER_KEY).
import type { PostJson } from "@scrolly/post-types";
import bomber from "./studio-bomber.generated.json";
import chat from "./studio-chat.generated.json";
import galerie from "./studio-galerie.generated.json";
import geschichte from "./studio-geschichte.generated.json";
import gpg from "./studio-gpg.generated.json";
import leben from "./studio-leben.generated.json";
import pass from "./studio-pass.generated.json";
import recherche from "./studio-recherche.generated.json";
import stimmeKi from "./studio-stimme-ki.generated.json";
import stimme from "./studio-stimme.generated.json";
import tor1 from "./studio-tor1.generated.json";

function mitKartenSchluessel(json: unknown): PostJson {
  const kopie = structuredClone(json) as {
    data: { data: { layers: { type: string; content: Record<string, unknown> }[] } };
  };
  const schluessel = import.meta.env.VITE_MAPTILER_KEY ?? "";
  for (const ebene of kopie.data.data.layers) {
    if (ebene.type === "map") ebene.content.apiKey = schluessel;
  }
  return kopie as unknown as PostJson;
}

export const mockPostJsonStudioTor1 = mitKartenSchluessel(tor1);

// Tor 2: Drehbuch von der Maschine geschrieben (scripts/studio/drehbuch-planen.ts).
export const mockPostJsonStudioGpg = mitKartenSchluessel(gpg);
export const mockPostJsonStudioLeben = mitKartenSchluessel(leben);
export const mockPostJsonStudioPass = mitKartenSchluessel(pass);

// Erzählform „Stimme“ (Tor 0, von Hand geschrieben): Zitate + Verlauf + Zeitleiste.
export const mockPostJsonStudioStimme = mitKartenSchluessel(stimme);

// Erzählform „Stimme“, Drehbuch von der Maschine (Tor 2).
export const mockPostJsonStudioStimmeKi = mitKartenSchluessel(stimmeKi);

// Zitate mit Übersetzung, Ereignisse mit eigener Quelle (Tor 2, Maschine).
export const mockPostJsonStudioBomber = mitKartenSchluessel(bomber);

// Recherche-Stufe: Material selbst gesucht, jede Quelle von unserem Code geprüft.
export const mockPostJsonStudioRecherche = mitKartenSchluessel(recherche);

// Kapitel: Geschichte in sieben Kapiteln, Zitatfetzen im Text (von Hand, jede Aussage geprüft).
export const mockPostJsonStudioGeschichte = mitKartenSchluessel(geschichte);

// Geschichte zuerst: Chats sieben Texte, geprüft, pro Text ein Bild.
export const mockPostJsonStudioChat = mitKartenSchluessel(chat);

// Beat-Bibliothek: neue Beats einzeln zum Abnehmen auf dem Handy.
export const mockPostJsonStudioGalerie = mitKartenSchluessel(galerie);
